export default __webpack_public_path__ + "static/media/bubble-02.b7a3cf5f.png";